import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import queryString from "querystring";
import { ignoreAuthPaths, ROUTE_ROOT_URI } from '@config/index'
import { ErrorBlock } from 'antd-mobile'

import RzIndex from "@src/pages/rzIndex";
import UploadID from "@src/pages/uploadID";
import Calculator from "@src/pages/rzIndex/page/calculator";
import ApplyQualification from '@src/pages/ApplyQualification'
import RzStatus from "@src/pages/rzStatus";
import Agreement from "@src/pages/agreement";
import Apply from "@src/pages/apply";
import Mine from "@src/pages/mine";
import Ins from "@src/pages/ins";
// import LoginError from "@src/pages/test";



export const history = createBrowserHistory();

const LoginError = function () {
	const isUpgrade = window.location.search.includes('type=upgrade')
	if (isUpgrade) {
		return (
			<div className='upgrade-page'>
				<div className='upgrade-text'>温馨提示：尊敬的客户，服务升级中，敬请期待！</div>
			</div>
		)
	}
	return (
		<div className='abnormal'>
			<ErrorBlock title="登录异常" description="请退出页面重新进入" status='disconnected' />
		</div>
	)
}


export function goto(path: string, query?: any) {
	if (query) {
		path = `${ROUTE_ROOT_URI}${path}?${queryString.stringify(query)}`
	} else {
		path = `${ROUTE_ROOT_URI}${path}`
	}
	history.push(path)
}

export function gotor(path: string, query?: any) {
	if (query) {
		path = `${ROUTE_ROOT_URI}${path}?${queryString.stringify(query)}`
	} else {
		path = `${ROUTE_ROOT_URI}${path}`
	}
	history.replace(path)
}

export function goBack() {
	history.goBack()
}

export default function () {
	return <Router history={history}>
		<Switch>
			{
				ignoreAuthPaths.map((r, i) => {
					return <Route path={r.path} component={r.component} key={i} />
				})
			}
			{/* 登录失败 */}
			<Route path={`${ROUTE_ROOT_URI}/loginError`} component={LoginError} />
			{/*  */}
			<Route path={`${ROUTE_ROOT_URI}/ins`} component={Ins} />
			<Route path={`${ROUTE_ROOT_URI}/rzIndex`} exact component={RzIndex} />
			{/* 金融计算器 */}
			<Route path={`${ROUTE_ROOT_URI}/rzIndex/calculator`} exact component={Calculator} />
			<Route path={`${ROUTE_ROOT_URI}/uploadId`} exact component={UploadID} />
			<Route path={`${ROUTE_ROOT_URI}/instalments`} component={ApplyQualification} />
			<Route path={`${ROUTE_ROOT_URI}/rzStatus`} component={RzStatus} />
			<Route path={`${ROUTE_ROOT_URI}/agreement`} component={Agreement} />
			<Route path={`${ROUTE_ROOT_URI}/apply`} component={Apply}></Route>
			<Route path={`${ROUTE_ROOT_URI}/order`} component={Mine}></Route>
			<Redirect exact to={`${ROUTE_ROOT_URI}/ins`} />
		</Switch>
	</Router>
}